import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "start", "end", "ellipsis", "children", "hasChipEllipsis"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Truncate.styles';
import Tooltip from '../Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Truncate = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 8 : _ref$start,
      _ref$end = _ref.end,
      end = _ref$end === void 0 ? 8 : _ref$end,
      _ref$ellipsis = _ref.ellipsis,
      ellipsis = _ref$ellipsis === void 0 ? '...' : _ref$ellipsis,
      children = _ref.children,
      _ref$hasChipEllipsis = _ref.hasChipEllipsis,
      hasChipEllipsis = _ref$hasChipEllipsis === void 0 ? false : _ref$hasChipEllipsis,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-truncate"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var str = children;
  var txtChars = str.length;
  var txtBandwidth = start + end;
  var endLeft = start;
  var startRight = Math.ceil(txtChars - end);
  var isTrimmed = txtChars > txtBandwidth;

  function renderContent() {
    if (isTrimmed && hasChipEllipsis) {
      return _jsxs(_Fragment, {
        children: [_jsx(Styled.Text, {
          children: str.substr(0, endLeft)
        }), _jsx(Tooltip, {
          position: "top",
          size: "medium",
          content: str,
          children: _jsx(Styled.EllipsisChip, {
            size: "small",
            children: ellipsis
          })
        }), _jsx(Styled.Text, {
          children: str.substr(startRight)
        })]
      });
    } else if (isTrimmed) {
      return _jsx(Tooltip, {
        position: "top",
        size: "medium",
        content: str,
        children: str.substr(0, endLeft) + ellipsis + str.substr(startRight)
      });
    } else {
      return str;
    }
  }

  return _jsx(Styled.Truncate, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: renderContent()
  }));
});
Truncate.displayName = 'Truncate';
export default Truncate;